module.exports = __webpack_public_path__ + "0d349d53e0bfa5dccb81a0e655a5bdcb.svg";